var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDugood4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 178,
    viewBox: "0 0 225 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.54 177.727C39.675 177.727 0.321289 141.97 0.321289 89.0926C0.321289 36.2148 39.675 0.258789 112.54 0.258789C185.405 0.258789 224.987 36.2444 224.987 89.0926C224.987 141.941 185.405 177.727 112.54 177.727ZM112.54 131.63C132.556 131.63 143.798 120.831 143.798 89.1221C143.798 56.9626 132.556 46.393 112.54 46.393C92.5232 46.393 81.2814 56.9626 81.2814 89.1221C81.2814 120.831 92.5232 131.63 112.54 131.63Z",
    fill: "url(#paint0_linear_2826_77657)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2826_77657",
    x1: 16.4527,
    y1: -233.928,
    x2: 12.0136,
    y2: 246.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDugood4);
export default __webpack_public_path__ + "static/media/dugood4.3f68e54268f2af3d08dd0e0c639b216b.svg";
export { ForwardRef as ReactComponent };